import { Link } from 'react-router-dom';

const stats = [
  { label: '漫画作品', value: '12,000+', icon: 'ri-book-open-line' },
  { label: '每日更新', value: '200+', icon: 'ri-refresh-line' },
  { label: '活跃读者', value: '500万+', icon: 'ri-user-heart-line' },
  { label: '高清画质', value: '100%', icon: 'ri-hd-line' },
  { label: '免费阅读', value: '永久', icon: 'ri-vip-crown-line' },
];

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-foreground-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-wider uppercase mb-4">
            我们的理念
          </p>
          <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 md:mb-8">
            为每一位韩漫爱好者<br />打造极致的阅读体验
          </h3>
          <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-10 md:mb-12">
            我们致力于成为中文世界最优质的韩漫在线阅读平台。从内容筛选到阅读交互，每一个细节都经过精心打磨，只为了让您沉浸在漫画的世界中，享受最纯粹的阅读乐趣。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14 md:mb-16">
            <Link
              to="/category/romance"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full border border-foreground-600 text-white text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-foreground-900 rounded-lg p-4 md:p-5 text-left"
              >
                <div className="w-9 h-9 flex items-center justify-center mb-3">
                  <i className={`${stat.icon} text-foreground-400 text-xl`}></i>
                </div>
                <p className="font-heading text-xl md:text-2xl font-bold text-white mb-1">{stat.value}</p>
                <p className="text-foreground-500 text-xs">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}